import { collection, doc, onSnapshot, query } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * 処理セッションのステータスと結果をリアルタイムに監視する
 * メインドキュメントと results サブコレクションを統合して監視します。
 *
 * @param sessionId セッションID
 * @param callback 状態更新時のコールバック
 * @returns 監視を解除するための関数
 */
export function listenToProcessingStatus(
  sessionId: string,
  callback: (data: any) => void,
): () => void {
  console.log(`📡 Firestoreリスナー開始: processing_sessions/${sessionId}`);

  let mainData: any = null;
  const resultsMap: Record<string, any> = {};

  const emit = () => {
    if (mainData) {
      // サブコレクションの結果を配列に変換（インデックス順）
      const resultsArray = Object.keys(resultsMap)
        .sort((a, b) => parseInt(a, 10) - parseInt(b, 10))
        .map((key) => resultsMap[key]);

      callback({
        ...mainData,
        results_array: resultsArray,
      });
    }
  };

  // 1. メインドキュメントの監視
  const mainDocRef = doc(db, 'processing_sessions', sessionId);
  const unsubscribeMain = onSnapshot(
    mainDocRef,
    (docSnap) => {
      if (docSnap.exists()) {
        mainData = docSnap.data();
        emit();
      }
    },
    (error) => {
      console.error(`❌ Firestoreリスナー(Main)エラー [${sessionId}]:`, error);
    },
  );

  // 2. results サブコレクションの監視
  const resultsColRef = collection(db, 'processing_sessions', sessionId, 'results');
  const unsubscribeResults = onSnapshot(
    query(resultsColRef),
    (querySnap) => {
      querySnap.docChanges().forEach((change) => {
        const data = change.doc.data();
        const id = change.doc.id;
        if (change.type === 'removed') {
          delete resultsMap[id];
        } else {
          resultsMap[id] = data;
        }
      });
      emit();
    },
    (error) => {
      console.error(`❌ Firestoreリスナー(Results)エラー [${sessionId}]:`, error);
    },
  );

  // 両方の解除関数をまとめる
  return () => {
    console.log(`⏹️ Firestoreリスナー解除: ${sessionId}`);
    unsubscribeMain();
    unsubscribeResults();
  };
}
